import styled from "@emotion/styled";
import type { ReactNode } from "react";

import { PageSection } from "@skilitics/designer-ui-components";

import { LayoutGroup } from "./styled.tsx";

export interface DangerZoneSectionProps {
  children: ReactNode;
}

export const DangerZoneSection = ({ children }: DangerZoneSectionProps) => (
  <Container
    header={
      <>
        <Header>Danger Zone</Header>
        <p>Actions that require careful consideration.</p>
      </>
    }
  >
    <LayoutGroup>{children}</LayoutGroup>
  </Container>
);

const Container = styled(PageSection)`
  outline: 2px solid ${({ theme }) => theme.error};
`;

const Header = styled.h3`
  color: ${({ theme }) => theme.error};
`;

export const DangerSummary = styled.div`
  font-size: 14px;

  h3 {
    font-size: 16px;
    margin: 0;
    line-height: 2;
  }

  p {
    margin: 0;
  }

  ul {
    line-height: 1.5;
  }

  .color {
    color: ${({ theme }) => theme.error};
  }
`;
